import React, { useState } from 'react';
import { AppDispatch, RootState } from 'src/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { TextField } from 'src/components/new/inputs/TextField';
import { handleAutoExclusionChange } from 'src/features/company/companySlice';

interface AddExclusionProps {
  open: boolean;
  mode: 'Edit' | 'Add';
  onClose: () => void;
  onSuccess: () => void;
}

const AddExclusion: React.FC<AddExclusionProps> = ({ open, onClose, onSuccess, mode }) => {
  const dispatch: AppDispatch = useDispatch();

  const [exclusionError, setExclusionError] = useState('');

  const exclusionName = useSelector((state: RootState) => state.company.autoExclusionForm.value);
  const exclusions = useSelector((state: RootState) => state.user.currentUser.thirteenTrusteeAddressExclusions) || [];

  const handleSubmit = () => {
    let newError = '';
    if (exclusionName === '') {
      newError = 'Name is required';
    }
    if (exclusions.includes(exclusionName)) {
      newError = 'Name already excluded';
    }

    setExclusionError(newError);

    if (!newError) {
      onSuccess();
      onClose();
    }
  };

  const handleClose = () => {
    setExclusionError('');
    onClose();
  };

  const handleChange = (e: any) => {
    dispatch(handleAutoExclusionChange(e.target.value));
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} sx={{ minWidth: '27.5rem' }}>
        <ModalTitle small onClose={handleClose}>
          {mode} Auto Exclusion
        </ModalTitle>
        <ModalContent small>
          <TextField
            required
            value={exclusionName}
            name="autoExclusion"
            id="autoExclusion"
            onChange={handleChange}
            error={exclusionError}
            label="Recipient Name"
          />
        </ModalContent>
        <ModalFooter onSubmit={handleSubmit} submitText="Save" />
      </Modal>
    </>
  );
};

export default AddExclusion;
